import AcademicYears from '@/views/academic/AcademicYears.vue';
import AddAcademicYear from '@/views/academic/AddAcademicYear.vue';
import EditAcademicYear from '@/views/academic/EditAcademicYear.vue';
import PromotionDashboard from '@/views/academic/PromotionDashboard.vue';
import PromotionHistory from '@/views/academic/PromotionHistory.vue';

export default [
  {
    path: '/academic',
    name: 'academic',
    meta: { 
      requiresAuth: true,
      requiredPerm: 'academic_years.display'
    },
    children: [
      {
        path: 'years',
        name: 'academic.years',
        component: AcademicYears,
        meta: { 
          title: 'academic.years_title',
          requiresAuth: true,
          requiredPerm: 'academic_years.display'
        }
      },
      {
        path: 'years/add',
        name: 'academic.years.add',
        component: AddAcademicYear,
        meta: { 
          title: 'academic.add_year',
          requiresAuth: true,
          requiredPerm: 'academic_years.create'
        }
      },
      {
        path: 'years/edit/:id',
        name: 'academic.years.edit',
        component: EditAcademicYear,
        meta: { 
          title: 'academic.edit_year',
          requiresAuth: true,
          requiredPerm: 'academic_years.update'
        },
        props: true
      },
      {
        path: 'promotion',
        name: 'academic.promotion',
        component: PromotionDashboard,
        meta: { 
          title: 'promotion.dashboard_title',
          requiresAuth: true,
          requiredPerm: 'student_promotion.display'
        }
      },
      {
        path: 'promotion-history',
        name: 'academic.promotion-history',
        component: PromotionHistory,
        meta: { 
          title: 'promotion.history_title',
          requiresAuth: true,
          requiredPerm: 'promotion_history.display'
        }
      }
    ]
  }
];